import React, { Component } from 'react';

class PrivacyPolicyMain extends Component {
  constructor(props) {
    super(props)
    this.state = {
      sta: '1',
      message: "",
      recruitData: [],
    }
  }

  initData() {
    {
      let res = {
        "message": "请求数据成功",
        "c_recruit": [
          {
            "contents": "",
            "id": "",
            "contTitle": "当社で取扱う個人情報の利用目的"
          },
          {
            "contents": "|当社で取り扱う個人情報の利用目的は以下の通りです。",
            "id": "",
            "contTitle": ""
          },
          
          {
            "contents": "|<table class='privacy-policy-table'><tr><th>NO</th><th>個人情報</th><th>利用目的</th></tr><tr><td>1</td><td>お取引先の皆様に関する個人情報</td><td>当社各事業に係る連絡、協力、交渉、契約履行等を行うため<br>当社に関連する商品・サービスをご紹介するため</td></tr><tr><td>2</td><td>お問合せされた皆様に関する個人情報</td><td>当社各事業、商品、サービスに関するお問合せに対応するため</td></tr><tr><td>3</td><td>従業員に関する個人情報</td><td>人事管理、勤務状況の管理、給与支払いを行うため<br>社会保険制度の運用管理、税務、健康診断、安全衛生などの業務を行うため<br>法令等に定める手続きの実施、その他会社の業務を遂行するため</td></tr><tr><td>4</td><td>採用募集者に関する個人情報</td><td>採用選考を行うため<br>採用選考手続き及びその結果に関する連絡を行うため<br>入社前手続き実施とその他の手続きに関する連絡を行うため</td></tr><tr><td>5</td><td>委託元からお預かりした個人情報</td><td>システムの受託開発に関する業務を遂行するため</td></tr><tr><td>6</td><td>協力会社からお預かりした個人情報</td><td>委託元への案内、提案を行うため<br>事務連絡などを行うため</td></tr></table>|",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "",
            "id": "",
            "contTitle": "保有個人データ又は第三者提供記録に関する事項の周知"
          },
          {
            "contents": "",
            "id": "",
            "contTitle": "1.事業者の氏名又は名称及び住所並びに代表者の氏名"
          },
          {
            "contents": "|SUN FLOWER SOFT株式会社",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|東京都千代田区神田須田町1－28－4　日宝神田ビル10階",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|代表取締役　陳　磊",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "",
            "id": "",
            "contTitle": "2.個人情報保護管理者（もしくはその代理人）の氏名または職名、所属及び連絡先"
          },
          {
            "contents": "|個人情報保護管理者　代表取締役",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|個人情報保護管理者へのご連絡は、お問合せ窓口までご連絡ください。",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "",
            "id": "",
            "contTitle": "3．すべての保有個人データの利用目的"
          },
          {
            "contents": "|「当社で取扱う個人情報の利用目的」の1～4を参照ください。",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "",
            "id": "",
            "contTitle": "4.苦情・相談の申し出先"
          },
          {
            "contents": "|個人情報の取扱いに関するお問合せ、苦情及びご相談につきましては、お問合せ窓口までご連絡ください。 ",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "",
            "id": "",
            "contTitle": "5.開示等の請求に応じる手続"
          },
          {
            "contents": "|1)保有個人データまたは第三者提供記録について",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|当社は、本人又は代理人からの求めにより、利用目的の通知、開示、内容の訂正、追加又は削除、利用の停止、消去、第三者への提供の停止、第三者提供記録の開示（以下、「開示等」という）に応じます。開示等の請求については、お問合せ窓口までご連絡ください。開示等を請求される場合には、当社所定の書面に必要事項をご記入の上、提出をお願いいたします。",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|ただし、「当社で取扱う個人情報の利用目的」に記載されている「5委託元からお預かりした個人情報」「6協力会社からお預かりした個人情報」については、開示等の請求には応じることが出来ませんので、ご了承ください。その利用目的は委託された業務を遂行するためであり、それ以外の目的には一切利用いたしません。",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|2)請求の申出先",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|開示等の請求は、お問合せ窓口までご連絡ください。当社所定の書面に必要事項を記入の上、提出をお願いいたします。",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|3)本人確認について",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|開示等の請求にあたっては、本人確認をいたします。場合によっては、公的な証明書の写しをご郵送いただき、確認を行いますので、ご了承ください。",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|※ 代理人については、委任状をご提出いただき確認を行います。なお、代理人を立てる場合には、ご本人と代理人両者の公的証明書のコピーを提出いただく必要がございます。",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|※ 未成年者または成年被後見人の法定代理人の場合は、法的な代理権を証明する書類で代理権があることを確認いたします。",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|4)手数料について",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|開示等の請求のうち「利用目的の通知」「個人情報または第三者提供記録の開示」については、1,000円を上限に手数料を徴収いたします。",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "",
            "id": "",
            "contTitle": "6.保有個人データの安全管理措置について"
          },
          {
            "contents": "|当社は、保有個人データを保護するため、以下の安全管理措置を講じています。その他、安全管理措置に関する詳細なご質問は、お問合せ窓口までご連絡ください。",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|1)基本方針の策定",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|・個人データの適正な取扱いの確保について取り組むために、基本方針を策定しています。",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|2)個人データの取扱いに係る規律の整備",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|・個人データの漏えい等の防止その他の個人データの安全管理のために、個人データの取扱いに係る規程類を策定しています。",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|3)組織的安全管理措置",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|・個人データの取扱いに関する責任者を任命するとともに、法令又は規程に違反している事実やおそれを把握した場合における責任者への報告連絡体制を整備しています。",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|・個人データを取り扱う従業者及び当該従業者が取り扱う個人データの範囲を明確化しています。",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|・個人データの取扱状況を確認するため、定期的に自己点検の実施や外部の者による審査を受けています。",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|・個人データの取扱状況の把握及び見直しを行い、個人情報保護体制の改善に取り組んでいます。",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|4)人的安全管理措置",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|・個人データの取扱いに関して、個人情報保護の重要性を周知・啓発し、定期的な教育を実施しています。",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|・個人データを取扱う従業者から秘密保持に関する誓約書を取得しています。",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|5)物理的安全管理措置",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|・個人データを取扱う区域において従業者および来訪者の入退室管理を行っています。",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|・個人データを取扱う機器、書類、電子媒体等の利用、保管、廃棄等に関する措置を定め、盗難又は紛失等を防止するための措置を講じています。",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|6)技術的安全管理措置",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|・アクセス制御を実施して、担当者及び取り扱う個人情報データベース等の範囲を限定しています。",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|・個人データを取扱う情報システムに対する、個人情報データベース等を取り扱う情報システムを使用する従業者を識別・認証しています。",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|・個人データを取扱う情報システムを外部からの不正アクセス又は不正ソフトウェアから保護する仕組みを導入しています。",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|7)外的環境の把握",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|・外国における個人情報の取扱いについて、当該外国の個人情報の保護に関する制度を把握したうえで上記安全管理を適切に講じています。",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "",
            "id": "",
            "contTitle": "7.個人情報お問合せ窓口"
          },
          {
            "contents": "|お問合せ窓口の連絡先は以下のとおりです。",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|SUN FLOWER SOFT株式会社　お問合せ窓口",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|info@sunflower-soft.com",
            "id": "",
            "contTitle": ""
          },
          {
            "contents": "|当社では、より良くお客様の個人情報保護を図るため、及び法令等の変更に対応するために、「個人情報の取扱いについて」を改定することがあります。",
            "id": "",
            "contTitle": ""
          },
        ]
      }
      res.contentArr = res.c_recruit
      delete res.c_recruit
      let recruitData = [];
      recruitData[0] = { contentArr: res.contentArr }
      this.setState({ "recruitData": recruitData })
    }
  }

  componentDidMount() {
    this.initData()
  }
  render() {
    // 社員採用
    let recruitList = this.state.recruitData.map((recruit) => {
      // 主标题  
      let titleItem = (
        <div className="privacy-policy-title">
          <h1>個人情報の取扱いについて</h1>
        </div>
      );

      let contentItems = recruit.contentArr.map((cont) => {
        // 处理普通内容项  
        let contenA = cont.contents.split('|');
        let num = 0;
        const content = contenA.map((content, key) => {
          if (contenA[0] === content) {
            return <span key={key}><p className="title">{cont.contTitle}</p>{content}</span>
          } else {
            num++;
            // 检查内容是否包含HTML标签，如果包含则使用dangerouslySetInnerHTML
            if (content.includes('<') && content.includes('>')) {
              return <p key={num} style={{ paddingLeft: 30 }} dangerouslySetInnerHTML={{ __html: content }}></p>
            } else {
              return <p key={num} style={{ paddingLeft: 30 }}>{content}</p>
            }
          }
        })

        return (<li key={cont.id}>{content}</li>)
      }).filter(item => item !== null); // 过滤掉null值

      return (
        <div className="content" key={1}>
          {titleItem}
          <ol key="recruit.id">
            {contentItems}
          </ol>
          <div className="privacy-policy-right-container">
          </div>
        </div>
      )
    })

    return (
      <div className="main-privacyPolicy" >
        <div className="layui-container">
          <div className="layui-row">
            {/* 社員採用 */}
            <div className="text">
              {recruitList}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default PrivacyPolicyMain
